export default __webpack_public_path__ + "827238cf40d5ad71cbace4a7b2c27c34.svg";